module.exports = __webpack_public_path__ + "static/media/Consumer-Affairs-Top-Rated.aafdf080.png";